import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { LayoutGrid } from 'lucide-react';
import NetworkSwitcher from './NetworkSwitcher';
import { UserMenu } from './UserMenu';

/**
 * The chrome every demo runs inside. A demo renders into `children` and owns nothing above it —
 * that is what keeps "switch demo" and "switch network" working the same way everywhere.
 */
export function DemoShell({ title, children }: { title?: string; children: ReactNode }) {
  return (
    /* --shell-header-h lets a demo position its own fixed chrome (the Journeys sidebar is
       `fixed top-0`) below this header instead of underneath it. The shell owns the value; a
       demo only consumes it, so neither has to hard-code the other's dimensions. */
    <div
      className="flex min-h-screen flex-col bg-viana-grid"
      style={{ ["--shell-header-h" as string]: "3.5rem" }}
    >
      <header className="relative z-[60] flex h-14 shrink-0 items-center justify-between gap-4 border-b border-slate-200 bg-white px-4">
        <div className="flex items-center gap-3 min-w-0">
          <Link
            to="/"
            className="flex items-center gap-2 rounded-lg px-2 py-1 text-sm font-semibold text-viana-primary hover:bg-slate-100"
          >
            <LayoutGrid className="h-4 w-4" aria-hidden />
            Viana Demos
          </Link>
          {title && (
            <>
              <span className="text-slate-300" aria-hidden>
                /
              </span>
              <span className="truncate text-sm text-slate-600">{title}</span>
            </>
          )}
        </div>
        <div className="flex items-center gap-4">
          <NetworkSwitcher />
          <UserMenu />
        </div>
      </header>
      <main className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">{children}</main>
    </div>
  );
}
